import { render } from "./areaDashboard.vue?vue&type=template&id=d11e0e32&scoped=true"
import script from "./areaDashboard.vue?vue&type=script&lang=js"
export * from "./areaDashboard.vue?vue&type=script&lang=js"

import "./areaDashboard.vue?vue&type=style&index=0&id=d11e0e32&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11e0e32"]])

export default __exports__